export default __webpack_public_path__ + "static/SRUS DS400 - Especification Del Producto y Datos Técnicos-b47bf8b8113ae83f3326e66f045d999c.pdf";